module.exports = __webpack_public_path__ + "img/point_active.5043f38d.svg";